import type { PageItemContextGateNotifyHandlerProps } from "./page-item-context-gate-notify-handler.type";

import { useOrganizationCustomContextNotify } from "@/modules/organization/organization-context";
import { useOnChange } from "@/utilities/effect";

export const PageItemContextGateNotifyHandler = ({
  itemContext,
}: PageItemContextGateNotifyHandlerProps) => {
  const { notifyContextChange } = useOrganizationCustomContextNotify();

  useOnChange(itemContext, notifyContextChange);

  return null;
};
